// components/MixpanelInitClient.tsx
"use client";

import { useEffect } from "react";
import { initMixpanel } from "@/lib/mixpanelClient";

export default function MixpanelInitClient() {
  useEffect(() => {
    initMixpanel(); // ✅ This runs ONLY on the client
  }, []);

  return null;
}
